<template>
  <div>
    <div class="py-2 py-md-4 d-flex flex-column">
      <div class="mb-3">
        <p class="h2 mb-0">{{ menu.title }}</p>
        <p class="text-muted text-sm mb-0">{{ menu.description }}</p>
      </div>
      <FormInput
        @input="setKeyword"
        :value="keyword"
        :placeholder="t.keyword_placeholder"
        type="text"
        name="keywords"
        class="mb-0"
      />
    </div>
    <div class="row">
      <div :style="`top: ${stickyHeight}px`" class="d-flex d-md-none w-100 sticky-wrapper mb-3">
        <ExpandButton
          id="categoryFilter"
          :should-toggle="false"
          v-open-modal="'categoryChooser'"
          :title="t.category"
          block
        />
      </div>
      <Modal :title="t.category_title" identifier="categoryChooser" is-full-mobile>
        <div class="text-left d-flex flex-column flex-grow-1">
          <LunchMenuFilters :t="t" @selectCategory="selectCategory" />
          <button v-close-modal="'categoryChooser'" class="mt-auto btn btn-primary btn-block">
            {{ t.show_results }}
          </button>
        </div>
      </Modal>
      <div class="col-md-6 col-lg-4 d-none d-md-block">
        <div :style="`top: ${stickyHeight}px`" class="sidebar-wrapper">
          <LunchMenuFilters :t="t" @selectCategory="selectCategory" />
        </div>
      </div>
      <div class="col-md-18 col-lg-19 offset-lg-1">
        <div v-if="visibleItems">
          <ReadMore
            :max_height="500"
            :more_text="t.show_more"
            :less_text="t.show_less"
            :should-hide-content="shouldHideContent"
            use_white_background
          >
            <LunchMenuCategoryListing
              v-bind="category"
              :key="`category-${category.title}`"
              :slug="`category-${index}`"
              :ref="`category-${index}`"
              v-for="(category, index) in visibleItems"
            />
          </ReadMore>
        </div>
        <div v-else>
          {{ t.results_empty }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReadMore from "./ReadMore.vue";
import FormInput from "./FormInput.vue";
import ExpandButton from "./ExpandButton";
import LunchMenuCategoryListing from "./LunchMenuCategoryListing";
import Modal from "./Modal";
import LunchMenuFilters from "./LunchMenuFilters";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LunchMenuList",
  components: {
    ExpandButton,
    LunchMenuCategoryListing,
    Modal,
    LunchMenuFilters,
    FormInput,
    ReadMore,
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
    cropContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      stickyHeight: "vendorShow/getStickyHeight",
      visibleItems: "lunchMenu/getVisibleItems",
      keyword: "lunchMenu/getKeyword",
    }),
    shouldHideContent() {
      return this.cropContent && this.visibleItems.length > 2;
    },
  },
  methods: {
    ...mapActions({
      setKeyword: "lunchMenu/setKeyword",
    }),
    selectCategory(idx) {
      let el = this.$refs[`category-${idx}`][0].$el;
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.sidebar-wrapper {
  position: sticky;
  top: 0;
  padding-top: $spacer-2;
}

.sticky-wrapper {
  background: $white;
  position: sticky;
  top: 0;
  left: $spacer-2;
  right: $spacer-2;
  z-index: $zi-high;
  padding-top: $spacer-2;
}
</style>
